import {APIService} from "./APIService";

export class WidgetService {
    static basePath = "/Widget";

    static getAlliePrice = () : Promise<number> => {
        return APIService.requests.get<number>(`${this.basePath}/GetAlliePrice`);
    }
}